import { GetUserResponseJSON } from "@performyard/service-contracts";

import request from "./internal-base-request";

export const fetchUser = async (userID: string): Promise<GetUserResponseJSON> => {
	const [response] = await request<GetUserResponseJSON>(`/v1/users/${userID}`);
	return response;
};
